import React, { useEffect, useRef, useState } from 'react'
import { useClientTypeUpdateQuery, useClientTypeUpdateSaveMutation } from '../../store/ReactWebSiteApi';
import { Modal, Form, Input, App } from 'antd';

function ClientTypeEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [infoEdit,setInfoEdit] = useState();
    const editForm = useRef()
    const {data,isSuccess} = useClientTypeUpdateQuery({ect_id:props.ect_id},{skip:!open})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                // console.log(dataEdit);
                editForm.current.setFieldsValue({
                    ect_name:data.Result.ect_name,
                })
                setInfoEdit(prevState=>({...prevState,
                    ect_name:data.Result.ect_name,
                }))
            }
        }
    },[data,isSuccess])
    const [submitUpdateSave] = useClientTypeUpdateSaveMutation()
    return (
        <>
            {props.ect_state==='2'&&                        
                        <a onClick={() => {setOpen(true)}}>修改</a>}
            <Modal
                open={open}
                title='修改客户类型'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    submitUpdateSave({
                        ect_name:infoEdit.ect_name,
                        ect_e_id:localStorage.getItem('e_id'),
                        ect_uid:localStorage.getItem('eu_id'),
                        ect_uname:localStorage.getItem('eu_name'),
                        ect_id:props.ect_id,
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 6 }}
                    ref={editForm}
                >
                    <Form.Item name="ect_name" label='客户类型名称' wrapperCol={{span:12}} required>
                        <Input  onChange={(e) => {setInfoEdit(prevState=>({...prevState,ect_name:e.target.value}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientTypeEdit